import React from 'react';
import { connect } from 'react-redux';
import { actions as formActions } from 'react-redux-form';
import { ModalOtpUniversia } from './modalOtpUniversia';
import { bindActionCreators } from 'redux';

const mapStateToProps = state => ({
    userProfile: state.userProfile,
});

const mapDispatchToProps = dispatch => ({
    formActions: bindActionCreators(formActions, dispatch),
});

export const ModalOtpUniversiaContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(props => {
    return <ModalOtpUniversia {...props} />;
});
